import * as MediaQueryActions from './actions';

export default (state = 'lg', action) => {
  switch (action.type) {
    case MediaQueryActions.SIZE_CHANGED:
      return action.size || state;
    default:
      return state;
  }
};
